/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { PageInfoFragmentDoc } from '../pageInfo/pageInfo.g';
import { ErrorFragmentDoc } from '../error/error.g';
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientApplicationFragment = { __typename: 'ClientApplicationType', id: string, createdAt: string, updatedAt: string, notes?: string | null, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, client: { __typename: 'ClientType', id: string, name: string }, employees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null } | null, resource: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, businessOwner?: { __typename: 'ClientEmployeeType', id: string } | null, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalEmployees: number } } | null };

export type ClientApplicationForTableFragment = { __typename: 'ClientApplicationType', id: string, createdAt: string, updatedAt: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, notes?: string | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resource: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalEmployees: number, totalNotifications: number, totalSessions: number, applicationCount: number }, primaryApplication?: { __typename: 'ClientApplicationType', id: string } | null } | null };

export type ClientApplicationsQueryVariables = Types.Exact<{
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  reviewState_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationReviewStateChoices>> | Types.InputMaybe<Types.TenantedClientApplicationReviewStateChoices>>;
  managedBy_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationManagedByChoices>> | Types.InputMaybe<Types.TenantedClientApplicationManagedByChoices>>;
  supportedBy_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationSupportedByChoices>> | Types.InputMaybe<Types.TenantedClientApplicationSupportedByChoices>>;
  businessOwner_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  resource_ProductName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  parentCategoryId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  createdAt_Gte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  createdAt_Lte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  resource_IsPrimaryResource?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasFileUploads?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasFileUploadsByEmployee?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type ClientApplicationsQuery = { __typename: 'Query', clientApplications?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, createdAt: string, updatedAt: string, notes?: string | null, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, client: { __typename: 'ClientType', id: string, name: string }, employees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null } | null, resource: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, businessOwner?: { __typename: 'ClientEmployeeType', id: string } | null, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalEmployees: number } } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ClientApplicationsTotalCountQueryVariables = Types.Exact<{
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  reviewState_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationReviewStateChoices>> | Types.InputMaybe<Types.TenantedClientApplicationReviewStateChoices>>;
  managedBy_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationManagedByChoices>> | Types.InputMaybe<Types.TenantedClientApplicationManagedByChoices>>;
  supportedBy_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationSupportedByChoices>> | Types.InputMaybe<Types.TenantedClientApplicationSupportedByChoices>>;
  businessOwner_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  resource_ProductName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  parentCategoryId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  createdAt_Gte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  createdAt_Lte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  resource_IsPrimaryResource?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ClientApplicationsTotalCountQuery = { __typename: 'Query', clientApplications?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null } | null };

export type ClientApplicationsForTableQueryVariables = Types.Exact<{
  clientId: Types.Scalars['ID']['input'];
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  reviewState_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationReviewStateChoices>> | Types.InputMaybe<Types.TenantedClientApplicationReviewStateChoices>>;
  managedBy_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationManagedByChoices>> | Types.InputMaybe<Types.TenantedClientApplicationManagedByChoices>>;
  supportedBy_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.TenantedClientApplicationSupportedByChoices>> | Types.InputMaybe<Types.TenantedClientApplicationSupportedByChoices>>;
  businessOwner_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  resource_ProductName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  parentCategoryId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  createdAt_Gte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  createdAt_Lte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type ClientApplicationsForTableQuery = { __typename: 'Query', clientApplications?: { __typename: 'ClientApplicationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientApplicationTypeEdge', node?: { __typename: 'ClientApplicationType', id: string, createdAt: string, updatedAt: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, notes?: string | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resource: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalEmployees: number, totalNotifications: number, totalSessions: number, applicationCount: number }, primaryApplication?: { __typename: 'ClientApplicationType', id: string } | null } | null } | null } | null> } | null };

export type ClientApplicationQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  clientApplicationId: Types.Scalars['UUID']['input'];
}>;


export type ClientApplicationQuery = { __typename: 'Query', clientApplication?: { __typename: 'ClientApplicationType', id: string, createdAt: string, updatedAt: string, notes?: string | null, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, client: { __typename: 'ClientType', id: string, name: string }, employees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null } | null, resource: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, businessOwner?: { __typename: 'ClientEmployeeType', id: string } | null, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalEmployees: number } } | null } | null };

export type CreateClientApplicationMutationVariables = Types.Exact<{
  input: Types.CreateClientApplicationMutationInput;
}>;


export type CreateClientApplicationMutation = { __typename: 'Mutation', createClientApplication?: { __typename: 'CreateClientApplicationMutation', application?: { __typename: 'ClientApplicationType', id: string, createdAt: string, updatedAt: string, notes?: string | null, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, client: { __typename: 'ClientType', id: string, name: string }, employees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null } | null, resource: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, businessOwner?: { __typename: 'ClientEmployeeType', id: string } | null, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalEmployees: number } } | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type UpdateClientApplicationMutationVariables = Types.Exact<{
  input: Types.UpdateClientApplicationMutationInput;
}>;


export type UpdateClientApplicationMutation = { __typename: 'Mutation', updateClientApplication?: { __typename: 'UpdateClientApplicationMutation', application?: { __typename: 'ClientApplicationType', id: string, createdAt: string, updatedAt: string, notes?: string | null, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, client: { __typename: 'ClientType', id: string, name: string }, employees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null } | null, resource: { __typename: 'ApplicationResourceType', id: string, vendorDomainName?: string | null, productDomainName?: string | null, vendorName?: string | null, vendorDescription?: string | null, productName?: string | null, productDescription?: string | null, isForConsumers: boolean, key?: string | null, isSaas: boolean, isVisible: boolean, resourceGroup?: { __typename: 'TenantedResourceGroupType', id: string } | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, businessOwner?: { __typename: 'ClientEmployeeType', id: string } | null, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', stats: { __typename: 'ResourceGroupStatsType', totalEmployees: number } } | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };

export type DeleteClientApplicationMutationVariables = Types.Exact<{
  input: Types.DeleteClientApplicationMutationInput;
}>;


export type DeleteClientApplicationMutation = { __typename: 'Mutation', deleteClientApplication?: { __typename: 'DeleteClientApplicationMutation', success?: boolean | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };


export const ClientApplicationFragmentDoc = `
    fragment ClientApplication on ClientApplicationType {
  id
  createdAt
  updatedAt
  client {
    id
    name
  }
  employees {
    totalCount
  }
  resource {
    id
    vendorDomainName
    productDomainName
    vendorName
    vendorDescription
    productName
    productDescription
    isForConsumers
    key
    isSaas
    isVisible
    resourceGroup {
      id
    }
    publicResource {
      category {
        id
        name
        parent {
          id
          name
        }
      }
      signedLogoUrl
    }
  }
  notes
  reviewState
  managedBy
  supportedBy
  businessOwner {
    id
  }
  resourceGroupApplications {
    stats {
      totalEmployees
    }
  }
}
    `;
export const ClientApplicationForTableFragmentDoc = `
    fragment ClientApplicationForTable on ClientApplicationType {
  id
  createdAt
  updatedAt
  reviewState
  managedBy
  supportedBy
  notes
  businessOwner {
    id
    name
  }
  resource {
    id
    vendorDomainName
    productDomainName
    vendorName
    vendorDescription
    productName
    productDescription
    isForConsumers
    key
    isSaas
    isVisible
    publicResource {
      signedLogoUrl
      category {
        id
        name
        parent {
          id
          name
        }
      }
    }
  }
  resourceGroupApplications {
    stats {
      totalEmployees
      totalNotifications
      totalSessions
      applicationCount
    }
    primaryApplication {
      id
    }
  }
}
    `;
export const ClientApplicationsDocument = `
    query ClientApplications($clientId: UUID, $after: String, $first: Int, $before: String, $last: Int, $offset: Int, $orderBy: String, $reviewState_In: [TenantedClientApplicationReviewStateChoices], $managedBy_In: [TenantedClientApplicationManagedByChoices], $supportedBy_In: [TenantedClientApplicationSupportedByChoices], $businessOwner_In: [ID], $resource_ProductName_Icontains: String, $parentCategoryId: UUID, $createdAt_Gte: DateTime, $createdAt_Lte: DateTime, $resource_IsPrimaryResource: Boolean, $hasFileUploads: Boolean, $hasFileUploadsByEmployee: UUID) {
  clientApplications(
    clientId: $clientId
    after: $after
    first: $first
    before: $before
    last: $last
    offset: $offset
    orderBy: $orderBy
    reviewState_In: $reviewState_In
    managedBy_In: $managedBy_In
    supportedBy_In: $supportedBy_In
    businessOwner_In: $businessOwner_In
    resource_ProductName_Icontains: $resource_ProductName_Icontains
    parentCategoryId: $parentCategoryId
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
    resource_IsPrimaryResource: $resource_IsPrimaryResource
    hasFileUploads: $hasFileUploads
    hasFileUploadsByEmployee: $hasFileUploadsByEmployee
  ) {
    edges {
      node {
        ...ClientApplication
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    ${ClientApplicationFragmentDoc}
${PageInfoFragmentDoc}`;

export const useClientApplicationsQuery = <
      TData = ClientApplicationsQuery,
      TError = unknown
    >(
      variables?: ClientApplicationsQueryVariables,
      options?: Omit<UseQueryOptions<ClientApplicationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientApplicationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientApplicationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ClientApplications'] : ['ClientApplications', variables],
    queryFn: fetcher<ClientApplicationsQuery, ClientApplicationsQueryVariables>(ClientApplicationsDocument, variables),
    ...options
  }
    )};

useClientApplicationsQuery.getKey = (variables?: ClientApplicationsQueryVariables) => variables === undefined ? ['ClientApplications'] : ['ClientApplications', variables];

export const useInfiniteClientApplicationsQuery = <
      TData = InfiniteData<ClientApplicationsQuery>,
      TError = unknown
    >(
      variables: ClientApplicationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientApplicationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientApplicationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientApplicationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ClientApplications.infinite'] : ['ClientApplications.infinite', variables],
      queryFn: (metaData) => fetcher<ClientApplicationsQuery, ClientApplicationsQueryVariables>(ClientApplicationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientApplicationsQuery.getKey = (variables?: ClientApplicationsQueryVariables) => variables === undefined ? ['ClientApplications.infinite'] : ['ClientApplications.infinite', variables];


useClientApplicationsQuery.fetcher = (variables?: ClientApplicationsQueryVariables) => fetcher<ClientApplicationsQuery, ClientApplicationsQueryVariables>(ClientApplicationsDocument, variables);

export const ClientApplicationsTotalCountDocument = `
    query ClientApplicationsTotalCount($clientId: UUID, $after: String, $first: Int, $before: String, $last: Int, $offset: Int, $orderBy: String, $reviewState_In: [TenantedClientApplicationReviewStateChoices], $managedBy_In: [TenantedClientApplicationManagedByChoices], $supportedBy_In: [TenantedClientApplicationSupportedByChoices], $businessOwner_In: [ID], $resource_ProductName_Icontains: String, $parentCategoryId: UUID, $createdAt_Gte: DateTime, $createdAt_Lte: DateTime, $resource_IsPrimaryResource: Boolean) {
  clientApplications(
    clientId: $clientId
    after: $after
    first: $first
    before: $before
    last: $last
    offset: $offset
    orderBy: $orderBy
    reviewState_In: $reviewState_In
    managedBy_In: $managedBy_In
    supportedBy_In: $supportedBy_In
    businessOwner_In: $businessOwner_In
    resource_ProductName_Icontains: $resource_ProductName_Icontains
    parentCategoryId: $parentCategoryId
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
    resource_IsPrimaryResource: $resource_IsPrimaryResource
  ) {
    totalCount
  }
}
    `;

export const useClientApplicationsTotalCountQuery = <
      TData = ClientApplicationsTotalCountQuery,
      TError = unknown
    >(
      variables?: ClientApplicationsTotalCountQueryVariables,
      options?: Omit<UseQueryOptions<ClientApplicationsTotalCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientApplicationsTotalCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientApplicationsTotalCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ClientApplicationsTotalCount'] : ['ClientApplicationsTotalCount', variables],
    queryFn: fetcher<ClientApplicationsTotalCountQuery, ClientApplicationsTotalCountQueryVariables>(ClientApplicationsTotalCountDocument, variables),
    ...options
  }
    )};

useClientApplicationsTotalCountQuery.getKey = (variables?: ClientApplicationsTotalCountQueryVariables) => variables === undefined ? ['ClientApplicationsTotalCount'] : ['ClientApplicationsTotalCount', variables];

export const useInfiniteClientApplicationsTotalCountQuery = <
      TData = InfiniteData<ClientApplicationsTotalCountQuery>,
      TError = unknown
    >(
      variables: ClientApplicationsTotalCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientApplicationsTotalCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientApplicationsTotalCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientApplicationsTotalCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ClientApplicationsTotalCount.infinite'] : ['ClientApplicationsTotalCount.infinite', variables],
      queryFn: (metaData) => fetcher<ClientApplicationsTotalCountQuery, ClientApplicationsTotalCountQueryVariables>(ClientApplicationsTotalCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientApplicationsTotalCountQuery.getKey = (variables?: ClientApplicationsTotalCountQueryVariables) => variables === undefined ? ['ClientApplicationsTotalCount.infinite'] : ['ClientApplicationsTotalCount.infinite', variables];


useClientApplicationsTotalCountQuery.fetcher = (variables?: ClientApplicationsTotalCountQueryVariables) => fetcher<ClientApplicationsTotalCountQuery, ClientApplicationsTotalCountQueryVariables>(ClientApplicationsTotalCountDocument, variables);

export const ClientApplicationsForTableDocument = `
    query ClientApplicationsForTable($clientId: ID!, $orderBy: String, $offset: Int, $first: Int, $reviewState_In: [TenantedClientApplicationReviewStateChoices], $managedBy_In: [TenantedClientApplicationManagedByChoices], $supportedBy_In: [TenantedClientApplicationSupportedByChoices], $businessOwner_In: [ID], $resource_ProductName_Icontains: String, $parentCategoryId: UUID, $createdAt_Gte: DateTime, $createdAt_Lte: DateTime) {
  clientApplications(
    clientId_In: [$clientId]
    resource_IsPrimaryResource: true
    orderBy: $orderBy
    offset: $offset
    first: $first
    reviewState_In: $reviewState_In
    managedBy_In: $managedBy_In
    supportedBy_In: $supportedBy_In
    businessOwner_In: $businessOwner_In
    resource_ProductName_Icontains: $resource_ProductName_Icontains
    parentCategoryId: $parentCategoryId
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
  ) {
    edges {
      node {
        ...ClientApplicationForTable
      }
    }
    totalCount
  }
}
    ${ClientApplicationForTableFragmentDoc}`;

export const useClientApplicationsForTableQuery = <
      TData = ClientApplicationsForTableQuery,
      TError = unknown
    >(
      variables: ClientApplicationsForTableQueryVariables,
      options?: Omit<UseQueryOptions<ClientApplicationsForTableQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientApplicationsForTableQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientApplicationsForTableQuery, TError, TData>(
      {
    queryKey: ['ClientApplicationsForTable', variables],
    queryFn: fetcher<ClientApplicationsForTableQuery, ClientApplicationsForTableQueryVariables>(ClientApplicationsForTableDocument, variables),
    ...options
  }
    )};

useClientApplicationsForTableQuery.getKey = (variables: ClientApplicationsForTableQueryVariables) => ['ClientApplicationsForTable', variables];

export const useInfiniteClientApplicationsForTableQuery = <
      TData = InfiniteData<ClientApplicationsForTableQuery>,
      TError = unknown
    >(
      variables: ClientApplicationsForTableQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientApplicationsForTableQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientApplicationsForTableQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientApplicationsForTableQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientApplicationsForTable.infinite', variables],
      queryFn: (metaData) => fetcher<ClientApplicationsForTableQuery, ClientApplicationsForTableQueryVariables>(ClientApplicationsForTableDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientApplicationsForTableQuery.getKey = (variables: ClientApplicationsForTableQueryVariables) => ['ClientApplicationsForTable.infinite', variables];


useClientApplicationsForTableQuery.fetcher = (variables: ClientApplicationsForTableQueryVariables) => fetcher<ClientApplicationsForTableQuery, ClientApplicationsForTableQueryVariables>(ClientApplicationsForTableDocument, variables);

export const ClientApplicationDocument = `
    query ClientApplication($clientId: UUID!, $clientApplicationId: UUID!) {
  clientApplication(id: $clientApplicationId, clientId: $clientId) {
    ...ClientApplication
  }
}
    ${ClientApplicationFragmentDoc}`;

export const useClientApplicationQuery = <
      TData = ClientApplicationQuery,
      TError = unknown
    >(
      variables: ClientApplicationQueryVariables,
      options?: Omit<UseQueryOptions<ClientApplicationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientApplicationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientApplicationQuery, TError, TData>(
      {
    queryKey: ['ClientApplication', variables],
    queryFn: fetcher<ClientApplicationQuery, ClientApplicationQueryVariables>(ClientApplicationDocument, variables),
    ...options
  }
    )};

useClientApplicationQuery.getKey = (variables: ClientApplicationQueryVariables) => ['ClientApplication', variables];

export const useInfiniteClientApplicationQuery = <
      TData = InfiniteData<ClientApplicationQuery>,
      TError = unknown
    >(
      variables: ClientApplicationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientApplicationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientApplicationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientApplicationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientApplication.infinite', variables],
      queryFn: (metaData) => fetcher<ClientApplicationQuery, ClientApplicationQueryVariables>(ClientApplicationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientApplicationQuery.getKey = (variables: ClientApplicationQueryVariables) => ['ClientApplication.infinite', variables];


useClientApplicationQuery.fetcher = (variables: ClientApplicationQueryVariables) => fetcher<ClientApplicationQuery, ClientApplicationQueryVariables>(ClientApplicationDocument, variables);

export const CreateClientApplicationDocument = `
    mutation CreateClientApplication($input: CreateClientApplicationMutationInput!) {
  createClientApplication(input: $input) {
    application {
      ...ClientApplication
    }
    errors {
      ...Error
    }
  }
}
    ${ClientApplicationFragmentDoc}
${ErrorFragmentDoc}`;

export const useCreateClientApplicationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClientApplicationMutation, TError, CreateClientApplicationMutationVariables, TContext>) => {
    
    return useMutation<CreateClientApplicationMutation, TError, CreateClientApplicationMutationVariables, TContext>(
      {
    mutationKey: ['CreateClientApplication'],
    mutationFn: (variables?: CreateClientApplicationMutationVariables) => fetcher<CreateClientApplicationMutation, CreateClientApplicationMutationVariables>(CreateClientApplicationDocument, variables)(),
    ...options
  }
    )};


useCreateClientApplicationMutation.fetcher = (variables: CreateClientApplicationMutationVariables) => fetcher<CreateClientApplicationMutation, CreateClientApplicationMutationVariables>(CreateClientApplicationDocument, variables);

export const UpdateClientApplicationDocument = `
    mutation UpdateClientApplication($input: UpdateClientApplicationMutationInput!) {
  updateClientApplication(input: $input) {
    application {
      ...ClientApplication
    }
    errors {
      ...Error
    }
  }
}
    ${ClientApplicationFragmentDoc}
${ErrorFragmentDoc}`;

export const useUpdateClientApplicationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientApplicationMutation, TError, UpdateClientApplicationMutationVariables, TContext>) => {
    
    return useMutation<UpdateClientApplicationMutation, TError, UpdateClientApplicationMutationVariables, TContext>(
      {
    mutationKey: ['UpdateClientApplication'],
    mutationFn: (variables?: UpdateClientApplicationMutationVariables) => fetcher<UpdateClientApplicationMutation, UpdateClientApplicationMutationVariables>(UpdateClientApplicationDocument, variables)(),
    ...options
  }
    )};


useUpdateClientApplicationMutation.fetcher = (variables: UpdateClientApplicationMutationVariables) => fetcher<UpdateClientApplicationMutation, UpdateClientApplicationMutationVariables>(UpdateClientApplicationDocument, variables);

export const DeleteClientApplicationDocument = `
    mutation DeleteClientApplication($input: DeleteClientApplicationMutationInput!) {
  deleteClientApplication(input: $input) {
    success
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;

export const useDeleteClientApplicationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteClientApplicationMutation, TError, DeleteClientApplicationMutationVariables, TContext>) => {
    
    return useMutation<DeleteClientApplicationMutation, TError, DeleteClientApplicationMutationVariables, TContext>(
      {
    mutationKey: ['DeleteClientApplication'],
    mutationFn: (variables?: DeleteClientApplicationMutationVariables) => fetcher<DeleteClientApplicationMutation, DeleteClientApplicationMutationVariables>(DeleteClientApplicationDocument, variables)(),
    ...options
  }
    )};


useDeleteClientApplicationMutation.fetcher = (variables: DeleteClientApplicationMutationVariables) => fetcher<DeleteClientApplicationMutation, DeleteClientApplicationMutationVariables>(DeleteClientApplicationDocument, variables);
